import { globalState } from '@/globalState';

function safeTrim(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).trim();
}

function readCookieValue(name) {
  if (typeof document === 'undefined') {
    return '';
  }
  const target = encodeURIComponent(String(name)) + '=';
  const cookies = document.cookie.split('; ');
  for (const c of cookies) {
    if (typeof c === 'string' && c.startsWith(target) === true) {
      const raw = c.slice(target.length);
      try {
        return decodeURIComponent(raw);
      } catch (e) {
        return raw;
      }
    }
  }
  return '';
}

function getAnyAuthToken() {
  if (globalState !== undefined && globalState !== null && globalState.authUsesHttpOnlyCookies === true) {
    return '';
  }
  const fromCookie = safeTrim(readCookieValue('authToken'));
  if (fromCookie.length > 0) {
    return fromCookie;
  }
  const fromJwtCookie = safeTrim(readCookieValue('jwtToken'));
  if (fromJwtCookie.length > 0) {
    return fromJwtCookie;
  }
  return '';
}

function getAllowedOrigins() {
  const origins = new Set();
  if (typeof window !== 'undefined' && window.location !== undefined && window.location !== null) {
    origins.add(window.location.origin);
  }
  const api = globalState !== undefined && globalState !== null ? globalState.apiEndpoint : undefined;
  const apiTrimmed = safeTrim(api);
  if (apiTrimmed.length > 0 && typeof window !== 'undefined' && window.location !== undefined && window.location !== null) {
    try {
      origins.add(new URL(apiTrimmed, window.location.origin).origin);
    } catch (e) {}
  }
  return origins;
}

function resolveRequestOrigin(config) {
  const urlValue = config !== undefined && config !== null ? config.url : undefined;
  const url = safeTrim(urlValue);
  if (url.length === 0) {
    return { origin: '', isRelative: true };
  }
  const isAbsolute = url.startsWith('http://') === true || url.startsWith('https://') === true;
  if (isAbsolute === false) {
    return { origin: '', isRelative: true };
  }
  try {
    const parsed = new URL(url);
    return { origin: parsed.origin, isRelative: false };
  } catch (e) {
    return { origin: '', isRelative: false };
  }
}

function shouldAttachAuth(config, allowedOrigins) {
  const resolved = resolveRequestOrigin(config);
  if (resolved.isRelative === true) {
    return true;
  }
  if (resolved.origin === '') {
    return false;
  }
  return allowedOrigins.has(resolved.origin) === true;
}

export function applyAxiosAuth(axiosLike, router) {
  if (axiosLike === undefined || axiosLike === null) {
    return;
  }

  axiosLike.interceptors.request.use(
    (config) => {
      const allowedOrigins = getAllowedOrigins();
      const cfg = config !== undefined && config !== null ? config : {};
      if (shouldAttachAuth(cfg, allowedOrigins) === true) {
        if (cfg.withCredentials === undefined) {
          cfg.withCredentials = true;
        }
        const headersRaw = cfg.headers !== undefined && cfg.headers !== null ? cfg.headers : {};
        const headers = { ...headersRaw };
        const authRaw = headers.Authorization !== undefined && headers.Authorization !== null ? headers.Authorization : headers.authorization;
        const hasAuthHeader = safeTrim(authRaw).length > 0;
        if (hasAuthHeader === false) {
          const token = getAnyAuthToken();
          if (token.length > 0) {
            headers.Authorization = `Bearer ${token}`;
          }
        }
        cfg.headers = headers;
      }
      return cfg;
    },
    (error) => Promise.reject(error)
  );
}


